export const SHIPPING_CREATE_REQUEST = "SHIPPING_CREATE_REQUEST";
export const SHIPPING_CREATE_SUCCESS = "SHIPPING_CREATE_SUCCESS";
export const SHIPPING_CREATE_FAIL = "SHIPPING_CREATE_FAIL";

export const SHIPPING_LIST_REQUEST = 'SHIPPING_LIST_REQUEST';
export const SHIPPING_LIST_SUCCESS = 'SHIPPING_LIST_SUCCESS';
export const SHIPPING_LIST_FAIL = 'SHIPPING_LIST_FAIL';

export const SHIPPING_DELETE_REQUEST = 'SHIPPING_DELETE_REQUEST';
export const SHIPPING_DELETE_SUCCESS = 'SHIPPING_DELETE_SUCCESS';
export const SHIPPING_DELETE_FAIL = 'SHIPPING_DELETE_FAIL';